import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  isEmpty,
} from 'lodash';
import {
  Field2 as Field,
  color,
} from 'vibeguide';
import {
  GridLegacy as Grid,
} from '@mui/material';

class MediaType extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      messageTypeOptions: [],
    };
  }

  componentDidMount() {
    this.updateMessageTypes();
  }

  componentDidUpdate(prevProps) {
    const {
      mediaFormat,
    } = this.props;

    const {
      mediaFormat: prevMediaFormat,
    } = prevProps;

    if (mediaFormat !== prevMediaFormat) {
      this.updateMessageTypes();
    }
  }

  updateMessageTypes = () => {
    const {
      isNew,
      user,
      mediaFormat,
    } = this.props;

    const canMessageUpload = user.can('message.upload');
    const canAdvertisementUpload = user.can('advertisement.upload');
    const canAdvertisementRequest = user.can('advertisement.request');
    const isAudioMessage = mediaFormat === 'audio';

    const messageTypeOptions = [
      {
        value: '',
        label: 'Select...',
      },
    ];

    switch (user.accountType) {
      case 'standard':
        messageTypeOptions.push({
          value: 'std',
          label: 'Self Promo',
        });
        if (canMessageUpload) {
        // Allow the user to upload a Self Promo message
          messageTypeOptions.push({
            value: 'ext',
            label: 'Self Promo (Upload)',
          });
        }

        if (!isNew && canAdvertisementRequest && user.can('admin.ism_admin')) {
          // Partner User that can create ads
          messageTypeOptions.push({
            value: 'ad',
            label: 'Ad',
          });
        }

        if (!isNew && canAdvertisementUpload && user.can('admin.ism_admin')) {
          // Allow the user to upload an ad
          messageTypeOptions.push({
            value: 'ext-ad',
            label: 'Ad (Upload)',
          });
        }

        if (user.isAdminCompany) {
          if (isAudioMessage) {
            // Allow user to create an Air Check
            messageTypeOptions.push({
              value: 'air',
              label: 'Air Check',
            });

            // Allow user to create an Spec Check
            messageTypeOptions.push({
              value: 'spec',
              label: 'Spec Spot',
            });
          }
        }
        break;

      case 'partner':
        if (canAdvertisementRequest) {
          // Partner User that can create ads
          messageTypeOptions.push({
            value: 'ad',
            label: 'Ad',
          });
        }

        if (canAdvertisementUpload) {
          // Allow the user to upload an ad
          messageTypeOptions.push({
            value: 'ext-ad',
            label: 'Ad (Upload)',
          });
        }

        break;
      default:
        break;
    }

    this.setState({
      messageTypeOptions,
    });
  };

  /**
   * When a field is changed

  onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      onUpdate,
    } = this.props;

    onUpdate({
      [name]: value,
    });
  };
     */

  /**
   * When the message type field is changed
   */
  onChangeType = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      type,
      onUpdate,
    } = this.props;

    const {
      ADMIN_COMPANY_ID: adminCompanyId,
    } = process.env;

    const data = {
      [name]: value,
      advertiserId: '',
      advertiserName: '',
    };

    if (value === 'air' || value === 'spec') {
      // Air Check, Spec Spot force location to Vibenomics ACAF
      // Force company to admin company
      data.companyId = adminCompanyId;
      data.companyName = 'Vibenomics, Inc.';

      data.startDate = '';
      data.endDate = '';
      data.locations = [{
        companyId: adminCompanyId,
        locationId: '*',
      }];
      data.locationsData = {
        companies: [{
          _id: adminCompanyId,
          locations: [],
          locationCount: '*',
        }],
        locations: [],
      };
      data.messageLists = [];
      data.messageBlocks = [];
    } else if (type === 'air' || type === 'spec') {
      // switching from ad (upload), air, or spec to not air, or spec, clear locations
      data.locations = [];
      data.locationsData = { companies: [], locations: [] };
    }

    if (value !== 'ad' || value !== 'ext-ad') {
      // If the previous type was ad, hide the selector
      // Remove the advertiser if one was selected
      data.advertiserId = '';
      data.advertiserName = '';
    }

    // if (value !== 'ad' || value !== 'ext-ad') {
    //   // If the previous type was ad, empty the company
    //   data.companyId = '';
    //   data.companyName = '';
    // }

    data.file = undefined;

    onUpdate(data);
  };

  selectMediaFormat = (mediaType) => {
    const {
      onUpdate,
      mediaFormat,
    } = this.props;

    if (isEmpty(mediaFormat) || mediaType !== mediaFormat) {
      onUpdate({
        mediaFormat: mediaType,
        messageType: '',
        locations: [],
        locationsData: {
          companies: [],
          locations: [],
        },
      });

      this.updateMessageTypes();
    }
  };

  render() {
    const {
      user,
      type,
      voiceTalentId,
      disableInput,
      mediaFormat,
      isNew,
      isCopy,
    } = this.props;

    const {
      messageTypeOptions,
    } = this.state;

    const isVoiceTalent = user.voiceTalent && user._id === voiceTalentId;

    return (
      <div className="Information">
        <Grid
          className="row"
          spacing={2}
          container
        >
          <Grid
            xs={12}
            item
          >
            <Field
              type="label"
              label="Media Type"
              required
            />

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
              }}
            >
              <Field
                type="radio"
                label="Audio"
                radioProps={{
                  selected: mediaFormat === 'audio',
                }}
                style={{
                  padding: '8px 16px',
                  border: mediaFormat === 'audio'
                    ? `1px solid ${color.primary}`
                    : '1px solid transparent',
                  backgroundColor: mediaFormat === 'audio'
                    ? color.yellow16
                    : 'transparent',
                }}
                disabled={!isNew && mediaFormat === 'visual'}
                onClick={() => this.selectMediaFormat('audio')}
                autoFocus
                tabIndex={1}
              />

              <Field
                type="radio"
                label="Visual"
                radioProps={{
                  selected: mediaFormat === 'visual',
                }}
                style={{
                  padding: '8px 16px',
                  border: mediaFormat === 'visual'
                    ? `1px solid ${color.primary}`
                    : '1px solid transparent',
                  backgroundColor: mediaFormat === 'visual'
                    ? color.yellow16
                    : 'transparent',
                }}
                disabled={!isNew && mediaFormat === 'audio'}
                onClick={() => this.selectMediaFormat('visual')}
                tabIndex={2}
              />
            </div>
          </Grid>

          {!isVoiceTalent && (
            <Grid xs={6} item>
              <Field
                type="select"
                label="Message Type"
                name="messageType"
                value={type}
                tabIndex={3}
                options={messageTypeOptions}
                disabled={disableInput || (!isNew && !isCopy) || !mediaFormat}
                onChange={this.onChangeType}
                required
              />
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

MediaType.propTypes = {
  type: PropTypes.string,
  voiceTalentId: PropTypes.string,
  disableInput: PropTypes.bool,
  isNew: PropTypes.bool,
  isCopy: PropTypes.bool,
  onUpdate: PropTypes.func,
};

MediaType.defaultProps = {
  type: 'std',
  voiceTalentId: '',
  disableInput: false,
  isNew: false,
  isCopy: false,
  onUpdate: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(MediaType);
